import * as Sentry from '@sentry/browser'

export interface CaptureContext {
  /** Searchable tags on the event, e.g. the block type and element id of a block that failed (GH #2809). No content */
  tags?: Record<string, string>
}

/** Report an error; resolves to the event id, so a UI can show it */
export const captureException = async (err: unknown, context?: CaptureContext) =>
  Sentry.captureException(err, context?.tags ? { tags: context.tags } : undefined)

/** The release errors are reported under (the build SHA), or undefined where Sentry is not set up */
export const errorReporterRelease = () => Sentry.getClient()?.getOptions().release
